
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faArrowLeft as farArrowLeft,
    } from '@fortawesome/pro-regular-svg-icons';

    export default {
        name: 'ADFJobsBanner',

        components: {
            FontAwesomeIcon,
        },

        data() {
            return {
                slideshowEl: [],
                currentSlideIndex: 0,
                icons: {
                    farArrowLeft,
                },
                slides: [
                    {
                        imageUrl: require('@/assets/img/ADF/adf-navy.webp'),
                        label: 'Australian Defence Force Navy',
                    },
                    {
                        imageUrl: require('@/assets/img/ADF/adf-airforce.webp'),
                        label: 'Australian Defence Force Air Force',
                    },
                    {
                        imageUrl: require('@/assets/img/ADF/adf-army.webp'),
                        label: 'Australian Defence Force Army',
                    },
                ],
            };
        },

        mounted() {
            this.initSlideshow();
        },

        methods: {
            initSlideshow() {
                this.slideshowEl = this.$refs.slideshow.children;
                this.showSlide(this.currentSlideIndex);
                setInterval(this.nextSlide, 4000);
            },

            showSlide(index) {
                Array.from(this.slideshowEl).forEach((slide, idx) => {
                    if (idx === index) {
                        slide.classList.add('fade-in');
                    } else {
                        slide.classList.remove('fade-in');
                    }
                });
            },
            nextSlide() {
                this.currentSlideIndex = (this.currentSlideIndex + 1) % this.slideshowEl.length;
                this.showSlide(this.currentSlideIndex);
            },

            emitAction() {
                this.$emit('action');
            },
        },
    };
